import { Service } from "../../service/service";

export class RootStore {
  constructor(readonly service: Service) {}
}
